import React from "react";
import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID
} from "./../editor-common";
import { handleAudioUpload } from ".//handle-audio-upload";
import {
  getVisibleOnlyOnDesktopResolver,
  selectedNodeResolver
} from "./../plugin-commons";
import {
  AlignmentPanel,
  NodeAlignmentButton,
  NodeSizeButton,
  SizePanel
} from "./../toolbars-ui";
import { FLOATING_PLUGIN_TOOLBAR } from "./../toolbars-v3";
import {
  AUDIO_BUTTONS,
  AUDIO_REPLACE_MODAL_ID,
  AUDIO_SETTINGS_MODAL_ID,
  PLUGIN_TOOLBAR_AUDIO_SETTINGS_BUTTON_ID
} from "./consts";
import { PLUGIN_TOOLBAR_AUDIO_SETTINGS_BUTTON } from "./data-hooks";
import { InsertModal } from "./modals/InsertModal";
import { AudioSettingsModal } from "./modals/SettingsModal";
import { AudioEditButton } from "./toolbar/AudioEditButton";
const isCustomAudioResolver = {
  id: "isCustomAudio",
  resolve: (content) => {
    if (Array.isArray(content) && content.length > 0) {
      return !!content[content.length - 1].attrs?.audio?.src?.id;
    } else {
      return false;
    }
  }
};
const getToolbarButtons = (config, services) => {
  const {
    modals,
    context: { isMobile }
  } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_AUDIO_SETTINGS_BUTTON_ID,
      dataHook: PLUGIN_TOOLBAR_AUDIO_SETTINGS_BUTTON,
      attributes: {
        visible: isCustomAudioResolver,
        selectedNode: selectedNodeResolver
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode }, publicCommands }) => {
        const { uploadService, updateService } = services;
        modals?.togglePluginPanel({
          id: AUDIO_SETTINGS_MODAL_ID,
          Component: AudioSettingsModal,
          componentProps: {
            nodeId: selectedNode.attrs.id,
            onFileSelect: () => {
              if (uploadService && updateService) {
                handleAudioUpload({
                  services,
                  config,
                  publicCommands,
                  nodeId: selectedNode.attrs.id,
                  type: "image"
                });
              }
            }
          },
          isMobile: isMobile2,
          positioning: {
            referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          focusReturnElement: referenceElement
        });
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(AudioEditButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isCustomAudioResolver,
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: ["SMALL", "CONTENT"]
        }),
        id: AUDIO_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: AUDIO_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: AUDIO_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: AUDIO_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      attributes: {
        active: {
          id: "IS_AUDIO_REPLACE_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }) => Boolean(modals2.getModal(AUDIO_REPLACE_MODAL_ID))
        }
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        const {
          audio: { src },
          id
        } = selectedNode.attrs;
        modals?.togglePluginPanel({
          id: AUDIO_REPLACE_MODAL_ID,
          Component: InsertModal,
          componentProps: {
            componentData: selectedNode.attrs,
            nodeId: id,
            handleFileSelection: config.handleFileSelection,
            handleFileUpload: config.handleFileUpload,
            fetchData: config.fetchData,
            embedType: src.url,
            modalId: AUDIO_REPLACE_MODAL_ID
          },
          isMobile: isMobile2,
          positioning: {
            referenceElement,
            placement: "bottom"
          },
          mobileLayout: "drawer"
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
